import React from 'react';
import { Redirect } from 'react-router-dom';
import { useFeatureFlag, useFeatureFlagContext } from '../../hooks/useFeatureFlag';

/**
 * Wraps a route component so a direct URL cannot reach it while the given feature flag is off.
 * Renders nothing until the flags resolve — gated pages fetch on mount, and with the flag off
 * those calls 404 at the API and raise error toasts. Apply it in routeConfig around the lazy()
 * component, so a disabled page's chunk never loads.
 */
export const withFeatureFlag = (Component, flagKey, redirectTo = '/home') => {
    const FeatureFlagGate = (props) => {
        const { isLoading: featureFlagsLoading } = useFeatureFlagContext();
        const isEnabled = useFeatureFlag(flagKey);

        if (featureFlagsLoading) return null;
        if (!isEnabled) return <Redirect to={redirectTo} />;

        return <Component {...props} />;
    };

    return FeatureFlagGate;
};

export default withFeatureFlag;
